<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Keringanan</h5>
            </template>

            <DetailGadaiKomp :detailGadai="dataGadai" />

            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA AJUAN KERINGANAN</h6>
                <b-row v-if="keringanan.status == 0" class="mb-4 ml-0">
                    <b-button name="cekInquiryPPBtn" variant="pgiBtn" @click="cekPP">Cek Inquiry Perpanjangan</b-button>
                    <b-button class="ml-2" name="cekInquiryPLBtn" variant="pgiBtn" @click="cekPL">Cek Inquiry Pelunasan</b-button>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status</b-col>
                    <b-col v-if="keringanan.status == 0" >
                        DIAJUKAN
                    </b-col>
                    <b-col v-else-if="keringanan.status == 1" >
                        DITERIMA
                    </b-col>
                    <b-col v-else-if="keringanan.status == 2" >
                        DITOLAK
                    </b-col>
                    <b-col v-else-if="keringanan.status == 3" >
                        DIGUNAKAN
                    </b-col>
                    <b-col v-else>
                        -
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nominal Ajuan</b-col>
                    <b-col>Rp. {{$helper.addThousandSeparator(keringanan.nominalRequest)}}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Direquest oleh</b-col>
                    <b-col>{{ keringanan.createdBy }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Direquest pada</b-col>
                    <b-col>{{ $helper.changeDateFormat(keringanan.tanggalRequest )}} {{ $helper.changeDateFormatGetHour(keringanan.tanggalRequest )}}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                    <b-col v-if="$helper.isNotNullAndNotEmpty(keringanan.keterangan)">{{ keringanan.keterangan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Foto Bukti</b-col>
                    <b-col v-if="$helper.isNotNullAndNotEmpty(keringanan.fotoBukti)">
                        <span class="mr-1" v-for="(item, idx) in keringanan.fotoBukti"  v-bind:key="idx">
                            <a v-bind:href="$baseFilePath+item" target="_blank">
                                <img width="150px" :src="$baseFilePath+item" alt="Foto Pendukung 3">
                            </a>
                        </span>
                    </b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>

            <div v-if="keringanan.status != 0" class="detail-data-wrapper mb-4">
                <h6 class="form-title">HASIL AJUAN KERINGANAN</h6>
                <b-row v-if="keringanan.status != 2" class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nominal Disetujui</b-col>
                    <b-col>Rp. {{$helper.addThousandSeparator(keringanan.nominalApproved)}}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Diproses pada</b-col>
                    <b-col v-if="keringanan.tanggalProcessed != null">{{ $helper.changeDateFormat(keringanan.tanggalProcessed )}} {{ $helper.changeDateFormatGetHour(keringanan.tanggalProcessed )}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Diproses oleh</b-col>
                    <b-col v-if="keringanan.processedBy != null">{{ keringanan.processedBy }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                    <b-col v-if="$helper.isNotNullAndNotEmpty(keringanan.keteranganApproval)">{{ keringanan.keteranganApproval }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            
            <b-form v-if="keringanan.status == 0" @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">APPROVAL KERINGANAN</h6>
                    <b-form-group label="Status">
                        <b-row>
                            <b-col md="4">
                                <b-form-group>
                                    <label class="radio-label">
                                        <b-form-radio v-model="input.isApproved" value="true">Setujui</b-form-radio>
                                    </label>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group>
                                    <label class="radio-label">
                                        <b-form-radio v-model="input.isApproved" value="false">Tolak</b-form-radio>
                                    </label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="4" md="6">
                                <b-form-group label="Keterangan">
                                    <b-form-textarea v-model="keteranganApproval" name="keterangan"></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form-group>
                    
                    <b-form-group label="Nominal">
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.nominalApproved" name="nominalApproved" :disabled="input.isApproved == 'false'"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="keringananSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
            <ModalConfirm id="modal-confirm-edit" title="Confirm Keringanan" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengganti status keringanan ini?" @submit="onSubmit" />
        </b-card>

        <b-modal id="modal-data-inquiry" title="Inquiry" :hide-footer="hideFooter" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title">INQUIRY - <span v-if="tipeInquiry === 'PL'">PELUNASAN</span><span v-else>PERPANJANGAN</span></h6>
                <ul class="list-pembayaran-wrapper">
                    <li v-for="(item, idx) in dataCekInquiry.items"  v-bind:key="idx">
                        <p class="mb-0">{{item.name}}</p>
                        <p v-if="item.nominal == null">{{$helper.addThousandSeparator(item.nominal)}} </p>
                        <p v-else>Rp. {{$helper.addThousandSeparator(item.nominal)}} </p>
                    </li>
                </ul>
                <div class="pl-4">
                    <p class="mb-0">Total : <strong>Rp. {{ $helper.addThousandSeparator(dataCekInquiry.total) }}</strong></p>
                    <p class="mb-0 smallText text-muted">Jatuh Tempo Selanjutnya : {{ $helper.changeDateFormat( dataCekInquiry.jatuhTempoSelanjutnya) }}</p>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DetailGadaiKomp from '../../../components/gadai/DetailGadaiKomp'

export default {
    name: 'detail-keringanan',
    components: {
        DetailGadaiKomp
    },
    data(){
        return{
            id: null,
            noFaktur: null,
            isSubmitting: false,
            initStatus: 0,
            keringanan: {},
            dataGadai: {},
            input: {
                keterangan: "",
                isApproved: null,
                nominalApproved: null
            },
            hideFooter: true,
            keteranganApproval: "",
            tipeInquiry: null,
            dataCekInquiry: {}
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id
            this.noFaktur = this.$route.params.noFaktur

            let getSingleDataGadai = this.$axios.get(`gadai/detail/faktur/${this.noFaktur}`).then(response => {
                this.dataGadai = response.data
            })

            let getSingleKeringanan = this.$axios.get(`gadai-keringanan-pembayaran/${this.id}`).then(response => {
                this.keringanan = response.data

                if (this.keringanan.status == 1) this.input.isApproved = "true"
                else if (this.keringanan.status == 2) this.input.isApproved = "false"
                
                if (this.keringanan.nominalRequest != null) this.input.nominalApproved = this.$helper.addThousandSeparator(this.keringanan.nominalRequest)
            })

            Promise.all([getSingleDataGadai, getSingleKeringanan]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        cekPP(){
            this.tipeInquiry = "PP"
            this.$axios.get("gadai-pembayaran/inquiry/?jenis=PP&noFaktur=" + this.noFaktur).then(response => {
                this.$bvModal.show("modal-data-inquiry")
                this.dataCekInquiry = response.data
            })
            .catch(error => {
                console.log(error)
                this.$helper.parseError(this, error)
            })
        },

        cekPL(){
            this.tipeInquiry = "PL"
            this.$axios.get("gadai-pembayaran/inquiry/?jenis=PL&noFaktur=" + this.noFaktur).then(response => {
                this.$bvModal.show("modal-data-inquiry")
                this.dataCekInquiry = response.data
            })
            .catch(error => {
                console.log(error)
                this.$helper.parseError(this, error)
            })
        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()
            let nominal = null

            if (this.input.isApproved == 'true') {
                nominal = this.$helper.removeThousandSeparator(this.input.nominalApproved)
                if (this.keteranganApproval != "") payload.append('keterangan', this.keteranganApproval)
            }
            else {
                nominal = this.keringanan.nominalRequest
                payload.append('keterangan', this.keteranganApproval)
            }

            //----------------- Append Data Keringanan -----------------
            
            payload.append('id', this.id)
            payload.append('nominal', nominal)
            payload.append('approve', this.input.isApproved)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post('gadai-keringanan-pembayaran/approval', payload).then(() => {
                this.$bvModal.hide("modal-confirm-edit")
                this.$helper.setFlash("Proses pengajuan keringanan berhasil dilakukan!")

                let path = this.$route.path.split("/")
                path.pop()
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if (this.input.nominalApproved == null || this.input.nominalApproved == "" || this.input.isApproved == null){
                this.$helper.toastErr(this, "Mohon lengkapi data penggantian status ajuan keringanan!")
            }
            else if (this.input.isApproved == 'false' && this.keteranganApproval == ""){
                this.$helper.toastErr(this, "Mohon isi keterangan!")
            }
            else {
                this.$bvModal.show("modal-confirm-edit")
            }
        }
    },

    watch: {
        "input.nominalApproved": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalApproved = result);
        },
    },

    created(){
        this.init()
    }
}
</script>
